import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { useIsMobile } from '@sravni/react-utils';

import { useDictionaries } from 'entities/creditForm';

export const AutoBrand: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  const isMobile = useIsMobile();

  const { autoBrands } = useDictionaries(['autoBrands']);

  return (
    <ControlledCustomSelect
      {...props}
      name={type}
      options={autoBrands}
      mobile={isMobile}
    />
  );
};
